import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";
import React, { useEffect, useState } from "react";

/*BootstrapTable anbd table Related*/
import Button from "@material-ui/core/Button";
import Table from "@material-ui/core/Table";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import TextField from "@material-ui/core/TextField";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";

import WebConfiguratorList from "./WebConfiguratorList";

/*Other Components*/

/*Loader */
import FadeIn from "react-fade-in";

/*animation*/
import Loader from "../../common/loader/Loader";
/*Inputs*/
/*Styles*/
import "./WebConfiguratorRow.css";

const useStyles = makeStyles((theme) => ({
  root: {
    width: 10,
    height: 10,
  },
  button: {
    display: "block",
    marginTop: theme.spacing(2),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
}));
const priceFormatter = (cell, row) => {
  let isSelected = "";
  let isSelected0 = "";
  let isSelected1 = "";
  let isSelected2 = "";
  let isSelected3 = "";
  let isSelected4 = "";
  console.log("Formatting cell", cell);
  switch (cell) {
    case 0:
      isSelected0 = "checked";
      break;
    case 1:
      isSelected1 = "checked";
      break;
    case 2:
      isSelected2 = "checked";
      break;
    case 3:
      isSelected3 = "checked";
      break;
    case 4:
      isSelected4 = "checked";
      break;
    default:
      isSelected = "checked";
  }
  console.log("Formatting cell isSelected0", isSelected0);
  return `
    <input type="radio" id="isSelected0" name="age" value="0" ${isSelected0}>
    <label for="isSelected0">Keep Price</label><br>
    <input type="radio" id="isSelected1" name="age" value="1" ${isSelected1}>
    <label for="isSelected1">Credit use line, Cash Adjust win amount</label><br>
    <input type="radio" id="isSelected2" name="age" value="2" ${isSelected2}>
    <label for="isSelected2">Adjust Risk Amount</label><br>
    <input type="radio" id="isSelected3" name="age" value="3" ${isSelected3}>
    <label for="isSelected3">Adjust Win Amount</label><br>
    <input type="radio" id="isSelected4" name="age" value="4" ${isSelected4}>
    <label for="isSelected4">UseLine</label><br>
 
 `;
};
export default function WebConfiguratorRow(props) {
  const classes = useStyles();
  const [webConfiguratorRow, setWebConfiguratorRow] = React.useState([]);
  const [idWebRow, setIdWebRow] = React.useState(0);
  const [order, setOrder] = React.useState();
  const [userInfo, setUserInfo] = useState(
    JSON.parse(localStorage.getItem("userInfo"))
  );
  const [isLoading, setIsLoading] = React.useState(true);
  let IdWebColumn = props.WebColumn.idColumn;

  //let IdPeriod = '0';
  useEffect(() => {
    // Change for server api address

    GetColumnDetail();
  }, [IdWebColumn]);
  // const [selectedIdGame, setselectedIdGame] = useState();

  const GetColumnDetail = () => {
    //Change for server api address
    setIsLoading(true);
    const url =
      process.env.REACT_APP_API2_URL +
      "/WebConfigurator/WebColumnDetail_GetListInfo?idColumn=" +
      IdWebColumn;

    axios
      .get(url)
      .then((response) => response.data)
      .then((data) => {
        setWebConfiguratorRow(data);

        setIsLoading(false);
      });
  };
  function onAfterSaveCell(row, cellName, cellValue) {
    props.UpdateProfile(row);
  }
  function onAfterSaveCellRelated(row, cellName, cellValue) {
    UpdateWebRow(row);
  }
  function UpdateWebRow(row) {
    let WebConfiguratorRowRequest = {
      IdProfile: row.IdProfile,
      IdSport: row.IdSport,
      IdPeriod: row.IdPeriod,
      MLFav_Over: row.MLFav_Over,
      MLFav_Under: row.MLFav_Under,
      MLDog_Over: row.MLDog_Over,
      MLDog_Under: row.MLDog_Under,
      SpreadFav_Over: row.SprFav_Over,
      SpreadFav_Under: row.SprFav_Under,
      SpreadDog_Over: row.SprDog_Over,
      SpreadDog_Under: row.SprDog_Under,
      IdUser: userInfo.userId,
    };
    axios({
      method: "post",
      url: process.env.REACT_APP_API2_URL + "/Game/WebConfiguratorRow_Update",
      //url: 'https://localhost:44337/api/Game/WebConfiguratorRow_Update',
      data: WebConfiguratorRowRequest,
    }).then((response) => {
      if (response.data === "-1") {
        alert("Data Successfully Updated");
      }
      console.log("response", response);
    });
  }

  const options = {
    beforeShowError: (type, msg) => {
      this.setState({ errType: type, errMsg: msg });
      // return false or do not return will not trigger the toastr,
      // if you want the toastr popup, you should return true always.
    },
    afterDeleteRow: onAfterDeleteRow, // A hook for after droping rows.
  };

  function onAfterDeleteRow(rowKeys) {
    let RequestDTO = {
      idWebColumn: rowKeys[0],
      idWebRow: idWebRow,
      idUser: userInfo.userId,
    };
    axios({
      method: "post",
      url:
        process.env.REACT_APP_API2_URL +
        "/WebConfigurator/WebColumnDetail_Delete",
      //url: 'https://localhost:44337/api/WebConfigurator/WebColumnDetail_Delete',
      data: RequestDTO,
    }).then((response) => {
      if (response.data === 0) {
        alert("Data Successfully Deleted");
      }
    });
  }
  const setWebOnMem = (IdWebRow) => {
    setIdWebRow(IdWebRow);
  };

  const handleChangeOrder = (event) => {
    setOrder(event.target.value);
  };

  /*Loader*/
  /**/

  function InsertWebDetailColumn(row) {
    let RequestDTO = {
      idWebColumn: props.WebColumn.idColumn,
      idWebRow: idWebRow,
      rowOrder: order,
      IdUser: userInfo.userId,
    };
    axios({
      method: "post",
      url:
        process.env.REACT_APP_API2_URL +
        "/WebConfigurator/WebColumnDetail_Insert",
      //url: 'https://localhost:44337/api/WebConfigurator/WebColumnDetail_Insert',
      data: RequestDTO,
    }).then((response) => {
      if (response.data === "0") {
        GetColumnDetail();
        alert("Data Successfully Inserted");
      }
      console.log("response", response);
    });
  }

  const onRowSelect = (row, isSelected, e) => {
    if (isSelected) {
      setIdWebRow(row.IdWebRow);
    }
  };

  const selectRowProp = {
    mode: "checkbox",

    clickToSelect: true,
    onSelect: onRowSelect,
  };

  console.log("PROPS====== Settings setPeriodOnMem>", isLoading);
  return (
    <React.Fragment>
      <div class="main-div">
        {isLoading ? (
          <FadeIn>
            <div class="d-flex justify-content-center align-items-center">
              <Loader height={360} width={360} />
            </div>
          </FadeIn>
        ) : (
          ""
        )}

        <h2>Related Options By Game</h2>
        <Table>
          <TableRow style={{ backgroundColor: "white" }}>
            <TableCell>
              <div className="mb-2 web-options">
                <WebConfiguratorList
                  /* showDataTable={true}*/ isInput={true}
                  setWebOnMem={setWebOnMem}
                ></WebConfiguratorList>
              </div>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <div className="web-options">
                <TextField
                  classes={"w-full"}
                  size="small"
                  variant="outlined"
                  type="text"
                  label="Order"
                  value={order}
                  multiline={false}
                  onChange={handleChangeOrder}
                />
                <div className="flex justify-end">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={InsertWebDetailColumn}
                  >
                    Add
                  </Button>
                </div>
              </div>
            </TableCell>
          </TableRow>
        </Table>

        <Table>
          <TableRow>
            <TableCell>
              <br></br>
              <b>Profile Info</b>
              <br></br>

              <BootstrapTable
                data={webConfiguratorRow}
                options={options}
                //deleteRow={true}
                selectRow={selectRowProp}
                tableHeaderClass="th-web-rows"
              >
                <TableHeaderColumn
                  visible="none"
                  isKey={true}
                  hidden
                  dataField="IdWebColumn"
                  columnClassName="td-web-rows"
                >
                  IdWebColumn
                </TableHeaderColumn>

                <TableHeaderColumn
                  columnClassName="td-web-rows"
                  dataField="WebRowName"
                >
                  Web Row Name
                </TableHeaderColumn>
                <TableHeaderColumn
                  columnClassName="td-web-rows"
                  dataField="ColumnOrder"
                >
                  Column Order
                </TableHeaderColumn>
              </BootstrapTable>
            </TableCell>
          </TableRow>
        </Table>
      </div>
    </React.Fragment>
  );
}
